import React, { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { useMutation } from "@apollo/react-hooks";
import { uploadFileMutation } from "./../../graphql/mutations/fileMutations";
import gql from "graphql-tag";

const UPLOAD_FILE = gql(uploadFileMutation);

const Dropzone = ({ onUploadComplete, storageId = "public_images" }) => {
  const [uploadCounts, setUploadCounts] = useState({
    error: 0,
    success: 0,
    total: 0,
  });
  const onDrop = useCallback(
    (files) => {
      setUploadCounts({
        ...uploadCounts,
        total: uploadCounts.total + files.length,
      });
      for (let file of files) {
        uploadFile({ variables: { file, storageId } });
      }
    },
    [uploadCounts]
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  const [
    uploadFile,
    { data: uploadResult, loading: isUploading, error: uploadError },
  ] = useMutation(UPLOAD_FILE, {
    onCompleted: (result) => {
      const resolvedUploads = uploadCounts.success + 1;
      setUploadCounts({ ...uploadCounts, success: resolvedUploads });
    },
    onError: (e) => {
      const failedUploads = uploadCounts.error + 1;
      setUploadCounts({ ...uploadCounts, error: failedUploads });
    },
    update: (cache, { data }) => {
      if (!data.uploadFile) return false;
      if (!onUploadComplete) return false;
      onUploadComplete(cache, data);
    },
  });

  return (
    <div>
      <div className="pb-5" {...getRootProps()}>
        <input {...getInputProps()} />
        <div className="flex px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
          <div className="flex-1"></div>
          <div className="flex-1 justify-center">
            <div className="text-center">
              <svg
                className="mx-auto h-12 w-12 text-gray-400"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 48 48"
              >
                <path
                  d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p className="mt-1 text-sm text-gray-600">
                <button
                  type="button"
                  className="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition duration-150 ease-in-out"
                >
                  Dropzone
                </button>
              </p>
              <p className="mt-1 text-xs text-gray-500"></p>
            </div>
          </div>
          <div className="flex-1 text-right align-text-bottom">
            {uploadCounts.total > 0 && (
              <div>
                {uploadCounts.error > 0 && (
                  <span>
                    <span className="text-4xl text-red-700">
                      {uploadCounts.error}
                    </span>
                    <span className="text-4xl text-gray-400">/</span>
                  </span>
                )}
                <span className="text-4xl text-green-700">
                  {uploadCounts.success}
                </span>
                <span className="text-4xl text-gray-400">/</span>
                <span className="text-4xl text-blue-700">
                  {uploadCounts.total}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dropzone;
